import { AxiosError } from 'axios';
import { axiosAPI } from './axios-instance';
import { TransformedCard } from './lib/utils/transform-program';

let titlePdf: string;
function setLoader(flag: boolean) {
    const links = document.querySelectorAll('.js-favorite-window-download-btn');

    if (links.length > 0) {
        links.forEach((el) => {
            if (flag) {
                el.classList.add('is-loader');
            } else {
                el.classList.remove('is-loader');
            }
        });
    }
}

export function createPdf(favourites: TransformedCard[], title: string) {
    if (favourites.length === 0) return;
    titlePdf = title;
    const dataToSend = {
        programs: favourites,
    };
    const jsonFavouritesCards = JSON.stringify(dataToSend, null, 2);
    sendFavouritesProgram(jsonFavouritesCards);
}

async function sendFavouritesProgram(favouritesJson: ApiPostFavouritesProgramRequest) {
    setLoader(true);
    try {
        const data = await postFavouritesProgram(favouritesJson);

        if (data) {
            dowloadFile(data);
            setLoader(false);
        } else {
            addError();
        }
    } catch (err) {
        if (err instanceof AxiosError) {
            addError();
        } else {
            console.log(err);
        }
    }
    setLoader(false);
}

function addError() {
    const link = document.querySelector('.js-favorite-window-download-btn');
    link?.classList.add('is-error');
    setTimeout(() => {
        link?.classList.remove('is-error');
    }, 3000);
}

function dowloadFile(file: Blob) {
    const linkPdf = document.createElement('a');
    const objUrl = URL.createObjectURL(file);
    linkPdf.href = objUrl;
    linkPdf.download = titlePdf;
    linkPdf.click();
    linkPdf.remove();
    setTimeout(() => {
        window.URL.revokeObjectURL(objUrl);
    });
}

export type ApiPostFavouritesProgramRequest = string;

export type ApiPostFavouritesProgramResponse = Blob;

export type AppPostFavouritesProgramResponse = Blob;
export const postFavouritesProgram = (
    body: ApiPostFavouritesProgramRequest,
): Promise<AppPostFavouritesProgramResponse> => {
    return axiosAPI
        .post<ApiPostFavouritesProgramResponse>('/v1/programs/pdf', body, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((res) => res.data);
};
